import { render, staticRenderFns } from "./buscarDocu.vue?vue&type=template&id=a1aad840"
import script from "./buscarDocu.vue?vue&type=script&lang=js"
export * from "./buscarDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports